const APP_CONFIG = {
  version: "7.86.1",
  title: "Claire V7.86.1",
  version_client: "7.86.1",
};

export default APP_CONFIG;
